The icon image and tooltip to indicate candidate identity has been verified.
This field should be included if verifiedIndicator is true, and omitted if verifiedIndicator is false.
